import useSelectedTeam from "@/hooks/useSelectedTeam";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import { useState } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
const ShopifyLogo = "/img/shopify.svg";
const ShopifyLogo1 = "/img/shopify-1.png";
const ShopifyLogo2 = "/img/shopify-2.png";
const ShopifyLogo3 = "/img/shopify-3.png";
import { IconArrowLeft } from "@velaro/velaro-component-lib/";

export default function ShopifyOverview() {
  const [activeTab, setActiveTab] = useState("Overview");
  const navigate = useNavigate();
  const { teamId } = useSelectedTeam();

  return (
    <div className="">
      <div className="font-semibold group flex items-center gap-2 justify-between mb-6">
        <div className="flex items-center gap-2 ">
          <div className="w-14 h-14 border-slate-300 relative mr-4 rounded border p-1 content-center">
            <img className="w-40 place-self-center" src={ShopifyLogo} alt="" />
          </div>
          <div>
            <div className="font-semibold text-slate-gray-800 text-lg">
              Shopify
            </div>
            <div className="font-normal text-slate-gray-400 text-sm">
              Integrate Shopify to sync e-commerce activities with customer
              profiles directly.
            </div>
          </div>
        </div>
        <PrimaryBlueButton
          label="Connect"
          onClick={() =>
            navigate(`/integrations/shopify/shopifycreate`, {
              state: { teamId: teamId }
            })
          }
          prefixIcon={null}
          className="font-medium"
        />
      </div>
      <div className="flex border-b">
        <div
          className={`py-2 mr-4 cursor-pointer text-slate-800 text-sm border-b-2 border-b-[var(--BR-Border-Hover,#64748B)] px-3`}
          onClick={() => setActiveTab("overview")}
        >
          Overview
        </div>
      </div>
      <div className="pt-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full mb-6">
          <img
            src={ShopifyLogo1}
            alt="Image 1"
            className="w-full h-auto object-cover rounded"
          />
          <img
            src={ShopifyLogo2}
            alt="Image 2"
            className="w-full h-auto object-cover rounded"
          />
          <img
            src={ShopifyLogo3}
            alt="Image 3"
            className="w-full h-auto object-cover rounded"
          />
        </div>
        <div className="text-sm text-slate-800 space-y-3">
          <p>
            Connect your Shopify store to give your support team instant access to customer orders, products, and account details — directly inside every chat conversation.
          </p>
          <p>
            Once connected, AI workflow nodes can automatically look up orders, find customers by email or name, search your product catalog, and answer &ldquo;where is my order?&rdquo; questions without the agent needing to open Shopify separately.
          </p>
          <p>
            You can also map Shopify fields to the agent sidebar panel so agents can search and view customer records during live chats, or use Shopify data as variables in workflow nodes and HTTP requests.
          </p>
        </div>
      </div>
    </div>
  );
}

export function ShopifyBackToIntegrationLanding() {
  const navigate = useNavigate();
  return (
    <div
      className="flex cursor-pointer items-center gap-2 text-slate-600"
      onClick={() => navigate("/integrations")}
    >
      <IconArrowLeft className="h-6 w-6" />
      Back
    </div>
  );
}
